import type { PetCompatibilityResponseFilters } from '@rover/rsdk/src/apiClient/latest/model/petCompatibilityResponseFilters';
import { Logger } from '@rover/rsdk/src/modules/Logging';
import { setItem } from '@rover/utilities/localStorage.client';

/**
 * Written by the sitter profile's pet compatibility banner on each "No", so an open search tab
 * can apply the filters through a `storage` event.
 */
export const PET_COMPATIBILITY_SIGNAL_KEY = 'roverPetCompatibilitySignal';

export type PetCompatibilitySignal = {
  filters: PetCompatibilityResponseFilters;
  petNames: string[];
  timestamp: number;
};

export const writePetCompatibilitySignal = (signal: PetCompatibilitySignal): void => {
  try {
    setItem(PET_COMPATIBILITY_SIGNAL_KEY, JSON.stringify(signal));
  } catch (e) {
    // Storage can be full or blocked; the banner still works without the signal.
    Logger.info('Pet compatibility signal failed to write', {
      errorMessage: (e as Error).message,
    });
  }
};
